import { FooterContent } from '@globalonmedia/ui-components/dist/types/components/footer/footer.types'
import { Menu } from '@globalonmedia/ui-components/dist/types/components/header/menu.types'

import { menu } from './mockData/menu.mock'
import { footerText, footerContent } from './mockData/footer.mock'

//TODO: This is a stub for future menu customization according to GEO
export const api = {
  getMenu(): Menu {
    return menu
  },

  getFooterContent(): FooterContent {
    return footerContent
  },

  getFooterText(): string {
    return footerText
  },
}
